module.exports = require("./../../_gen/starling/animation/DelayedCall");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/animation/DelayedCall.js
// module id = 99
// module chunks = 0